var $c57738f6094a3d25$exports = {};
$c57738f6094a3d25$exports = {
    "(optional)": `(\u{9078}\u{586B})`,
    "(required)": `(\u{5FC5}\u{586B})`
};


export {$c57738f6094a3d25$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
